import { render, staticRenderFns } from "./SuggestMember.vue?vue&type=template&id=db73b596&scoped=true&"
import script from "./SuggestMember.vue?vue&type=script&lang=ts&"
export * from "./SuggestMember.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestMember.vue?vue&type=style&index=0&id=db73b596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db73b596",
  null
  
)

export default component.exports